import React from "react";
import { Link, useNavigate } from "react-router-dom";
import UniverseDecoderLogo from "../../assets/icons/universedecoder-logo.svg";
import "./styles.css";

const MainPage = () => {
  const navigate = useNavigate();

  return (
    <main className="ud-page">
      <header className="ud-header">
        <div className="ud-brand">
          <img src={UniverseDecoderLogo} alt="UniverseDecoder logo" />
          <span>
            Universe<span>decoder.</span>
          </span>
        </div>

        <nav className="ud-header-nav" aria-label="Main navigation">
          <Link to="/about" className="ud-about-link">
            About
          </Link>

          <span className="ud-studio-label">DIGITAL PRODUCT STUDIO</span>
        </nav>
      </header>

      <div className="ud-main">
        <section className="ud-hero">
          <img src={UniverseDecoderLogo} alt="" className="ud-hero-logo" />

          <h1>
            Universe<span>decoder.</span>
          </h1>

          <p>Decoding life, one thing at a time.</p>
        </section>

        <section className="ud-solutions">
          <div className="ud-section-heading">
            <span>OUR SOLUTIONS</span>
            <div />
          </div>

          <button
            className="ud-muscle-button"
            type="button"
            onClick={() => navigate("/muscleUp")}
          >
            <div className="ud-muscle-text">
              <div className="ud-muscle-coming-soon">
                <span className="ud-status-dot" />
                COMING SOON — DEC 15, 2026
              </div>

              <h2>Muscle Up</h2>
              <p>Your no-nonsense workout logger.</p>
            </div>

            <span className="ud-arrow" aria-hidden="true">
              →
            </span>
          </button>
        </section>

        <section className="ud-next">
          <div className="ud-section-heading">
            <span>WHAT'S NEXT</span>
            <div />
          </div>

          <h2>More ideas are brewing.</h2>
          <p>We're thinking of more awesome solutions.</p>
        </section>
      </div>

      <footer className="ud-footer">
        <span>© 2026 UNIVERSEDECODER</span>
        <span>BUILT WITH PURPOSE</span>
      </footer>
    </main>
  );
};

export default MainPage;